<template>
  <v-dialog :model-value="true" :max-width="900" height="100%" @update:model-value="close">
    <v-card class="pt-4 px-8 light-scrollbar">
      <v-btn-icon size="x-small" style="position: absolute; top: 4px; right: 4px" @click="close"><v-icon size="large">far fa-times</v-icon></v-btn-icon>
      <v-sheet class="mx-auto">
        <v-chip-group v-model="selectedTag" selected-class="text-primary" column mandatory @update:model-value="carouselCurrentIndex = 0">
          <v-chip v-for="tag in tags" :key="tag.value" :value="tag.value">{{ tag.text }}</v-chip>
        </v-chip-group>
      </v-sheet>
      <div>
        <v-carousel v-model="carouselCurrentIndex" show-arrows="hover" :cycle="! pauseCarousel" interval="10000" progress hide-delimiters :continuous="false"
                    height="max(536px, min(736px, calc(100vh - 112px)))"
                    @mouseenter="pauseCarousel = true" @mouseleave="pauseCarousel = false">
          <v-carousel-item v-for="(slide, index) in slides[selectedTag]" :key="`${selectedTag}-${index}`" :src="slide" class="mt-2"></v-carousel-item>
        </v-carousel>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import tips1 from './img/tips/1.png';
  import tips2 from './img/tips/2.png';
  import tips3 from './img/tips/3.png';
  import tips4 from './img/tips/4.png';
  import tips5 from './img/tips/5.png';
  import tips6 from './img/tips/6.png';
  import arbreDeDecisions from './img/tips/arbre-de-decisions.png';
  import automatisations from './img/tips/automatisations.png';
  import budget from './img/tips/budget.png';
  import choisirMonTDB1 from './img/tips/choisir-mon-tableau-de-bord-1.png';
  import choisirMonTDB2 from './img/tips/choisir-mon-tableau-de-bord-2.png';
  import ficheProjet from './img/tips/fiche-projet.png';
  import gestionCharge1 from './img/tips/gestion-charge-1.png';
  import gestionCharge2 from './img/tips/gestion-charge-2.png';
  import importCsv from './img/tips/import-csv.png';
  import importModele from './img/tips/import-modele.png';
  import intervenants from './img/tips/intervenants.png';
  import Kanban from './img/tips/kanban.png';
  import liaisons from './img/tips/liaisons.png';
  import macroBulle from './img/tips/macro-bulle.png';
  import modeles from './img/tips/modeles.png';
  import outilsProjets from './img/tips/outils-projets.png';
  import performance from './img/tips/performance.png';
  import personnalisation from './img/tips/personnalisation.png';
  import planningVsKanban from './img/tips/planning-vs-kanban.png';
  import recurrence from './img/tips/recurrence.png';
  import selectionMultiple from './img/tips/selection-multiple.png';
  import sousProjet from './img/tips/sous-projet.png';
  import statutsDeProjet from './img/tips/statuts-de-projet.png';
  import synchronisation from './img/tips/synchronisation.png';
  import tableauxDeBord1 from './img/tips/tableaux-de-bord-1.png';
  import tableauxDeBord2 from './img/tips/tableaux-de-bord-2.png';
  import tableauxDeBord3 from './img/tips/tableaux-de-bord-3.png';
  import tableauxDeBord4 from './img/tips/tableaux-de-bord-4.png';
  import tableauxDeBord5 from './img/tips/tableaux-de-bord-5.png';
  import tableauxDeBord6 from './img/tips/tableaux-de-bord-6.png';
  import tableauxDeBord7 from './img/tips/tableaux-de-bord-7.png';
  import versioning from './img/tips/versioning.png';
  import vuesTravail from './img/tips/vues-de-travail.png';

  export default {
    emits: ['close'],
    data() {
      const essentials = [tips1, tips2, tips3, tips4, tips5, tips6];
      const planification = [Kanban, planningVsKanban, liaisons, sousProjet, macroBulle, synchronisation];
      const projectManagement = [ficheProjet, budget, intervenants, gestionCharge1, gestionCharge2, statutsDeProjet];
      const dashboards = [choisirMonTDB1, choisirMonTDB2, arbreDeDecisions, tableauxDeBord1, tableauxDeBord2, tableauxDeBord3, tableauxDeBord4, tableauxDeBord5, tableauxDeBord6, tableauxDeBord7];
      const templates = [modeles, importModele, importCsv, vuesTravail, recurrence];
      const intermediate = [selectionMultiple, versioning, personnalisation, automatisations, outilsProjets, performance];

      return {
        slides: {
          essentials,
          planification,
          projectManagement,
          dashboards,
          templates,
          intermediate,
        },
        tags: [
          { value: 'essentials', text: 'Bien démarrer' },
          { value: 'planification', text: 'Planification' },
          { value: 'projectManagement', text: 'Suivi de projet' },
          { value: 'dashboards', text: 'Tableaux de bord' },
          { value: 'templates', text: 'Modèles & imports' },
          { value: 'intermediate', text: 'Aller plus loin' },
        ],
        selectedTag: 'essentials',
        carouselCurrentIndex: 0,
        pauseCarousel: false,
      };
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>
